import React from "react";

export default function Footer() {
  return (
    <footer className="border-t border-gray-100 bg-white mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-display font-black text-2xl">Mok.Jaa</div>
          <p className="text-sm text-gray-600 mt-3 max-w-sm">
            Authentic Korean food, delivered fresh & fast in Dimapur. 먹자 — Let's eat!
          </p>
          <a
            href="mailto:mokjaa.2022@gmail.com"
            className="inline-block text-sm text-gray-700 mt-4 hover:text-black underline underline-offset-4"
            data-testid="footer-email"
          >
            mokjaa.2022@gmail.com
          </a>
          <a
            href="https://wa.me/918798572458?text=Hi%20Mok.Jaa!%20I%20have%20a%20question%20about%20my%20order."
            target="_blank"
            rel="noopener noreferrer"
            className="block text-sm text-[#25D366] font-bold mt-2 hover:underline underline-offset-4"
            data-testid="footer-whatsapp"
          >
            Chat with us on WhatsApp →
          </a>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-gray-400 mb-3">Address</div>
          <div className="text-sm text-gray-700 leading-relaxed">
            WP75+M8F, Duncan Basti,<br />Dimapur, Nagaland 797113<br />India
          </div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-gray-400 mb-3">Hours</div>
          <div className="text-sm text-gray-700 leading-relaxed" data-testid="footer-hours">
            Tue – Sat · 12:30 – 20:20<br />
            Sun · 14:00 – 21:00<br />
            <span className="text-[#C85A5A] font-bold">Mon · Closed</span>
          </div>
        </div>
      </div>
      <div className="border-t border-gray-100 py-5 text-center text-xs text-gray-400">© {new Date().getFullYear()} Mok.Jaa · Est. 2022</div>
    </footer>
  );
}
